import styled from 'styled-components';

export const DrawingArea = styled.div`
    border: 1px solid black;
    display: inline-block;
    position: relative;
    left: 5000px;
    top: 5000px;
    width: 612px;
    height: 792px;
    background-color: white;
`;